import { style } from '@vanilla-extract/css';

/**
 * 页面版心。标准/宽版都用同一个页边档位 `--xuwo-page-margin-width`（96px），差别只在
 * 正文列：默认卡在 `--xuwo-page-frame-width`（正文 720 + 2×96 = 912）的外框上，
 * 宽版把外框放开成 100%、正文占满页边之间的剩余空间。铺满档将页边缩到 24px。
 * 标准/宽版与 Notion 的
 * `.layout` / `.layout-wide` 等价，档位出处见 theme/xuwo.css 的「页面版心」。
 *
 * 两态共用页边是必须的：早前默认是上游的 944/24、全宽是 100%/72，于是
 * 默认正文 = min(944, 容器) − 48、全宽正文 = 容器 − 144，两者在容器宽 1040px
 * 相交——容器窄于 1040 时开「全宽」反而让正文更窄。页边一致后全宽恒 ≥ 默认。
 */
export const editor = style({
  flex: 1,
  vars: {
    '--xuwo-editor-content-width': 'var(--xuwo-page-frame-width)',
  },
  selectors: {
    '&.fill-width': {
      vars: { '--xuwo-page-margin-width': '24px' },
    },
    '&.full-screen': {
      width: '100%',
      minWidth: 0,
      vars: {
        '--xuwo-editor-content-width': '100%',
      },
    },
  },
  '@media': {
    'screen and (max-width: 800px)': {
      selectors: {
        '&.is-public': {
          vars: {
            '--xuwo-editor-content-width': '100%',
            '--xuwo-page-margin-width': '24px',
          },
        },
      },
    },
  },
});

/**
 * 页面菜单 Small text(pageSmallText 属性):正文与标题整体缩一档。
 * 缩放系数对齐 Notion 的 14/16=0.875,基于本仓库默认档
 * (base 15 / h1 28…h6 18)取整;近似档,Notion 侧未采集,待补采。
 */
export const smallText = style({
  vars: {
    '--xuwo-font-base': '13px',
    '--xuwo-font-h-1': '24px',
    '--xuwo-font-h-2': '23px',
    '--xuwo-font-h-3': '21px',
    '--xuwo-font-h-4': '19px',
    '--xuwo-font-h-5': '18px',
    '--xuwo-font-h-6': '16px',
  },
});
